// Store locator with customisations
// - custom marker
// - custom info window (using Info Bubble)
// - custom info window content (+ store hours)
// https://cdn.shopify.com/s/files/1/0250/6781/4964/files/Untitled-3-Recovered.png?11088
// var ICON = new google.maps.MarkerImage('https://cdn.shopify.com/s/files/1/0250/6781/4964/files/Untitled-3-Recovered.png?11088', null, null,
//     new google.maps.Point(14, 13));

function pinSymbol(color) {
  return {
      url: 'https://cdn.shopify.com/s/files/1/0066/9653/4068/files/placeholder.png?v=1610440755',
      // fillColor: color,
      // fillOpacity: 1,
      // strokeColor: '#168483',
      // strokeWeight: 1,
      // scale: 1,
 };
}


google.maps.event.addDomListener(window, 'load', function() {
var map = new google.maps.Map(document.getElementById('map-canvas'), {
center: new google.maps.LatLng(50, -103),
zoom: 4,
mapTypeId: google.maps.MapTypeId.ROADMAP,
styles: [{
stylers: [{
  saturation: -100
}]
}]
});

var panelDiv = document.getElementById('panel');

var data = new MedicareDataSource;

var view = new storeLocator.View(map, data, {
geolocation: true
});

view.createMarker = function(store) {
var markerOptions = {
  position: store.getLocation(),
  icon: pinSymbol("#1eb0ae"),
  title: store.getDetails().title
};
return new google.maps.Marker(markerOptions);
}

var infoBubble = new InfoBubble;
view.getInfoWindow = function(store) {
if (!store) {
  return infoBubble;
}

var details = store.getDetails();

var html = ['<div class="store"><div class="title">', details.title,
  '</div><div class="address">', details.address, '</div>',
  '<div class="phone">', details.phone, '</div>',
  '<div class="fax">', details.fax, '</div>',
  '<div class="email">', details.email, '</div>',
  '</div>'].join('');

infoBubble.setContent($(html)[0]);
return infoBubble;
};

new storeLocator.Panel(panelDiv, {
view: view
});
});
